import { AppDispatch, RootState, store } from '../index';
import { FetchState } from '../fetchState';
import { getList, getListSort, ListFilter, listSlice, ListType } from '../listHelper';
import { CancelToken } from 'axios';
import { ReferenceDto } from '@api/models/employees/ReferenceDto';
import { UserRole } from '@api/models/enums/UserRole';
import { UserState } from '@api/models/enums/UserState';
import { EmployeeUserListResponse } from '@api/models/employees/EmployeeUserListResponse';
import { userService } from '@api/services/services';

export interface UserListFilter extends ListFilter {
  state?: Array<UserState>;
  roles?: Array<UserRole>;
  establishments: ReferenceDto[];
}

export type UserListState = ListType<EmployeeUserListResponse, UserListFilter>;

const initialState: UserListState = {
  state: FetchState.None,
  data: undefined,
  query: {
    state: [UserState.Active, UserState.Invited],
    sortBy: 'lastName',
    sortDesc: false,
    roles: [],
    establishments: [],
  },
};

export const userListSlice = listSlice({
  name: 'userList',
  initialState,
});

export const selectUserList = (state: RootState) => state.userList;
export const userListActions = userListSlice.actions;

export const getUserList = (cancelToken: CancelToken) => (dispatch: AppDispatch) => {
  const storeState = store.getState();
  const data = selectUserList(storeState);

  const handleGetData = (size: number) => {
    return userService.query(
      {
        q: data.query.q,
        state: data.query.state,
        roles: data.query.roles,
        establishments: data.query.establishments.map((x) => x.id),
        page: data.query.page,
        size: size,
        sort: getListSort(data),
      },
      { cancelToken: cancelToken as any },
    );
  };

  getList({
    dispatch,
    cancelToken,
    state: data.state,
    actions: userListActions,
    getData: handleGetData,
  });
};
